import { __extends, __assign } from 'tslib';
import React__default, { createRef } from 'react';
import clsx from 'clsx';
import Text from '../Text/Text.component.js';
import { TextTypes } from '../Text/Text.types.js';
import Tooltip from '../Tooltip/Tooltip.component.js';
import { Variants, propTypes, defaultProps } from './Label.types.js';
import styles from './Label.module.scss.js';

var Label = /** @class */ (function (_super) {
    __extends(Label, _super);
    function Label() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerContentRef = createRef();
        _this.state = {
            isTruncated: false,
        };
        _this.renderInnerContent = function () {
            var _a = _this.props, small = _a.small, large = _a.large, text = _a.text, variant = _a.variant, textColor = _a.textColor, icon = _a.icon;
            var textSize = small ? TextTypes.LABEL : TextTypes.P;
            return (React__default.createElement("div", { "data-testid": "content-wrapper", className: styles.LabelWrapper },
                icon && React__default.createElement("div", { className: styles.LabelContent_icon }, icon),
                React__default.createElement(Text, { className: clsx(styles['LabelContent_text'], variant && !textColor && styles.Label_text___variant, large && !small && styles['largeLabelText']), type: textSize, color: textColor, textRef: _this.innerContentRef }, text)));
        };
        _this.renderContent = function () {
            var _a = _this.props, altText = _a.altText, text = _a.text, tooltipProps = _a.tooltipProps;
            return _this.state.isTruncated ? (React__default.createElement(Tooltip, __assign({ className: styles.LabelContent_tooltip, tooltipContent: altText || text }, tooltipProps), _this.renderInnerContent())) : (_this.renderInnerContent());
        };
        return _this;
    }
    Label.prototype.componentDidMount = function () {
        var _a;
        var _b = this.props, variant = _b.variant, maxWidth = _b.maxWidth, testId = _b.testId;
        if (testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
        this.setState({
            isTruncated: !!((_a = this.innerContentRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) &&
                this.innerContentRef.current.scrollWidth > (maxWidth || 280),
        });
        if (variant &&
            ![
                Variants.INFORMATIVE,
                Variants.SUCCESS,
                Variants.DANGER,
                Variants.WARNING,
                Variants.BASE,
            ].includes(variant)) {
            console.error("ERROR: The " + variant + " is not supported.");
        }
    };
    Label.prototype.render = function () {
        var _a = this.props, small = _a.small, large = _a.large, className = _a.className, variant = _a.variant, backgroundColor = _a.backgroundColor, suffixIcon = _a.suffixIcon, testId = _a.testId, maxWidth = _a.maxWidth;
        var sizeClass = '';
        if (small && !large) {
            sizeClass = styles['Label___small'];
        }
        else if (!small && large) {
            sizeClass = styles['Label___large'];
        }
        return (React__default.createElement("div", { className: clsx(styles.Label, className, variant && styles["Label___" + variant], sizeClass), style: { background: backgroundColor }, "data-testid": this.props['data-testid'] || testId },
            React__default.createElement("div", { style: { maxWidth: maxWidth }, className: styles.LabelContent }, this.renderContent()),
            suffixIcon && (React__default.createElement("div", { className: styles.Label_suffixIcon }, suffixIcon))));
    };
    Label.displayName = 'Label';
    Label.propTypes = propTypes;
    Label.defaultProps = __assign({}, defaultProps);
    return Label;
}(React__default.Component));

export { Label as default };
